import _ from 'lodash'
import moment from 'moment-timezone'

import { getVenue, getSetupform } from 'selectors/entities'
import { createDeepEqualSelector } from 'utils/selectors'
import { EventGroupPurchaseTypes } from 'constants/eventgroup-constants'

export const getSetupformFields = (setupformId, fields) => (state) => {
  if (!state.entities.setupforms[setupformId]) {
    return null
  }

  const setupformFields = {}
  fields.forEach((field) => {
    setupformFields[field] = state.entities.setupforms[setupformId][field]
  })

  return setupformFields
}

export const getSetupformCommission = setupformId => (state) => {
  if (!state.entities.setupforms[setupformId]) {
    return null
  }
  return state.entities.setupforms[setupformId].commission
}

export const getSetupformVoucherFields = (setupformId, instanceId) => (state) => {
  if (!state.entities.setupforms[setupformId]) {
    return null
  }
  const instanceGroup = state.entities.setupforms[setupformId].instanceGroups.find(ig => ig.id === instanceId)
  if (!instanceGroup) {
    return null
  }

  return {
    instanceId: instanceGroup.instances[0].id,
    ticketType: instanceGroup.instances[0].ticketType,
    ticketCount: instanceGroup.ticketCount,
    voucherValidFrom: instanceGroup.instances[0].voucherValidFrom,
    voucherValidTo: instanceGroup.instances[0].voucherValidTo,
    onsaleTime: instanceGroup.instances[0].onsaleTime,
    offsaleTime: instanceGroup.instances[0].offsaleTime,
    discountPrice: instanceGroup.instances[0].discountPrice,
    initialPrice: instanceGroup.instances[0].initialPrice,
    commission: instanceGroup.instances[0].commission,
  }
}

export const getSetupformLastVoucherFields = setupformId => (state) => {
  if (!state.entities.setupforms[setupformId]) {
    return null
  }
  const instanceGroup = _.last(state.entities.setupforms[setupformId].instanceGroups)
  if (!instanceGroup) {
    return null
  }

  return {
    instanceId: instanceGroup.instances[0].id,
    ticketType: instanceGroup.instances[0].ticketType,
    ticketCount: instanceGroup.ticketCount,
    voucherValidFrom: instanceGroup.instances[0].voucherValidFrom,
    voucherValidTo: instanceGroup.instances[0].voucherValidTo,
    onsaleTime: instanceGroup.instances[0].onsaleTime,
    offsaleTime: instanceGroup.instances[0].offsaleTime,
    discountPrice: instanceGroup.instances[0].discountPrice,
    initialPrice: instanceGroup.instances[0].initialPrice,
    commission: instanceGroup.instances[0].commission,
  }
}

export const isNewVenue = state => state.pages.setupformPage.isNewVenue

export const getVenueSearchResults = state =>
  state.pages.setupformPage.venueSearchResults &&
  state.pages.setupformPage.venueSearchResults.map(venueId => getVenue(venueId)(state))

export const getImageId = state => state.pages.setupformPage.imageId

export const isUploadingImage = state => state.pages.setupformPage.isUploadingImage

export const isValidatingImage = state => state.pages.setupformPage.isValidatingImage

export const getImagePreview = state => state.pages.setupformPage.imagePreview

export const getCurrentSetupformId = state => state.pages.setupformPage.setupformId

export const getNewVenue = state => state.pages.setupformPage.newVenue

export const getNewVenueOriginal = state => state.pages.setupformPage.newVenueOriginal

export const isTracked = state => state.pages.setupformPage.tracked

export const getGroupedInstances = _.memoize(setupformId => createDeepEqualSelector(
  [getSetupform(setupformId)],
  setupform => setupform && _.sortBy(setupform.instances, instance => moment(instance.start_time).unix())
))

export const getEventGroupId = setupformId => (state) => {
  const setupform = getSetupform(setupformId)(state)
  return setupform ? setupform.eventGroupId : null
}

export const getCurrentSetupForm = (state) => {
  const setupformId = getCurrentSetupformId(state)
  if (setupformId == null) {
    return null
  }

  const setupform = getSetupform(setupformId)(state)
  return setupform
}

export const isVoucher = setupformId => state => (
  state.entities
  && state.entities.setupforms
  && state.entities.setupforms[setupformId]
  && state.entities.setupforms[setupformId].purchaseType === EventGroupPurchaseTypes.VOUCHER
)



/** WEBPACK FOOTER **
 ** ./src/selectors/setupform/setupform-selectors.js
 **/